import { useQuery } from "@apollo/client";
import { CenterResult } from "__legacy/components/CenterResult";
import { CenterSpinner } from "__legacy/components/CenterSpinner";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import { ProjectCertificatorsQuery as ProjectCertificatorsQueryType } from "./__generated__/ProjectCertificatorsQuery";

const ProjectCertificatorsQuery = loader("./ProjectCertificatorsQuery.gql");

type ProjectCertificatorsQueryProviderType = (props: {
  children: (data: ProjectCertificatorsQueryType) => ReactNode;
}) => ReactElement;

export const ProjectCertificatorsQueryProvider: ProjectCertificatorsQueryProviderType = (props) => {
  const { children } = props;

  const { error, loading, data } = useQuery<ProjectCertificatorsQueryType>(ProjectCertificatorsQuery, {
    fetchPolicy: "cache-and-network",
  });

  if (loading) return <CenterSpinner size="large" />;
  if (error || !data)
    return <CenterResult status="404" title="404" subTitle="Sorry, the page you visited does not exist." />;

  return <Fragment>{children(data)}</Fragment>;
};
